export function mapResetNorth(options = { animate: true }) { return this.setBearing(0, options); }
